import { render, staticRenderFns } from "./flats-crm-favorite.vue?vue&type=template&id=4bb298ab"
import script from "./flats-crm-favorite.vue?vue&type=script&lang=js"
export * from "./flats-crm-favorite.vue?vue&type=script&lang=js"
import style0 from "./flats-crm-favorite.vue?vue&type=style&index=0&id=4bb298ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports